/* eslint-disable */
import PropTypes from 'prop-types';
import UserEntityPropTypes from '../../Services/User/User.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ProfilePicPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * Whether or not the presence indicator should be hidden
   */
  hidePresence: PropTypes.bool,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * A user entity
   */
  user: UserEntityPropTypes.user.isRequired,
};

export default ProfilePicPropTypes;
